import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Avatar,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Slider,
  withStyles,
  FormControlLabel,
  Checkbox,
  Divider,
} from "@material-ui/core";
import TitleText from "../../components/reusableComponents/TitleText";
import Header from "../../components/reusableComponents/Header";
import BodyText from "../../components/reusableComponents/BodyText";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import SummaryForm from "../../components/reusableComponents/SummaryForm";
import TravellerForm from "../../components/reusableComponents/TravellerForm";
import {
  toggleGSTModal,
  toggleSessionExpireModal,
  toggleTermModal,
} from "../../reducers/UiReducer";
import { useDispatch } from "react-redux";
import AddGSTModal from "../../components/reusableComponents/AddGSTModal";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import TermConditionModal from "../../components/reusableComponents/TermConditionModal";
import BaggageForm from "../../components/reusableComponents/BaggageForm";
import FlightSummaryForm from "../../form/FlightSummaryForm";
import Drawers from "../../components/Drawers";
import Login from "../../components/reusableComponents/Login";
import { toggleLoginModal } from "../../reducers/UiReducer";
import SelectedOnwardEtravRow from "../../components/reusableComponents/SelectedOnwardEtravRow";
import SelectedReturnEtravRow from "../../components/reusableComponents/SelectedReturnEtravRow";
import SelectedOnwardTboRow from "../../components/reusableComponents/SelectedOnwardTboRow";
import HeaderSection from "../../components/reusableComponents/HeaderSection";
import SessionExpireModal from "../../components/reusableComponents/SessionExpireModal";
import FlightSummaryReturnForm from "../../form/FlightSummaryReturnForm";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiChip-sizeSmall": {
      height: 36,
    },
  },
  accodin: {
    "& .MuiAccordionSummary-content": {
      justifyContent: "space-between",
    },
  },
  radio: {
    "& .MuiTypography-body1": {
      fontSize: 13,
    },
  },
}));
const GreenCheckbox = withStyles({
  root: {
    color: "rgb(239, 51, 57)",
    "&$checked": {
      color: "rgb(239, 51, 57)",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
const SummaryFlight = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState("");
  const [value2, setValue2] = React.useState(false);
  const [val, setVal] = React.useState(false);
  const [b, setB] = React.useState(false);
  const { etravflightFare } = useSelector((state) => state.ui);
  const location = useLocation();
  const dispatch = useDispatch();
  // const handleChange = (event) => {
  // 	if (event.target.value !== value) {
  // 		setValue('female');
  // 	} else if (event.target.value == value) {
  // 		setValue('');
  // 	}
  // 	console.log(event.target.value);
  // };
  const handleClick = (event) => {
    if (event.target.value === value) {
      setValue("");
    } else {
      setValue(event.target.value);
    }
  };
  console.log(value);
  const {
    baggage,
    baggageAdult2,
    baggageAdult3,
    baggageAdult4,
    baggageAdult5,
    baggageAdult6,
    baggageAdult7,
    baggageAdult8,
    baggageAdult9,
    baggageChild1,
    baggageChild2,
    baggageChild3,
    baggageChild4,
    baggageChild5,
    baggageChild6,
    baggageChild7,
    baggageChild8,
    baggageChild9,
  } = useSelector((state) => state.ui);
  const [check, setCheck] = useState(false);
  const handleCheck = (event) => {
    // if (gst) {
    dispatch(toggleTermModal(true));
    // }

    // setCheck(event.target.checked);
  };
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr and " + rminutes + " min.";
  }
  function convertH2M(timeInHour) {
    console.log(timeInHour);
    var timeParts = timeInHour.split(":");
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
  }
  const countContainer = document.getElementById("countdown-number");
  const countContainer2 = document.getElementById("countdown-number2");

  // variable to store count
  let hr;
  let remainingTime = 100;

  // variable to store time interval
  let timer;
  const renderTime = () => {
    // decement time
    remainingTime -= 1;
    // render count on the screen

    const min = Math.floor(remainingTime / 60);
    let second = remainingTime % 60;
    countContainer.innerHTML = `${min}:${second}min`;
    // timeout on zero
    if (remainingTime === 0) {
      isStopped = true;
      clearInterval(timer);
      // Play audio on timeout
      // timeoutAudio.play();
      remainingTime = 100;
      dispatch(toggleSessionExpireModal(true));
      setValue2(false);
      // alert('Finish');
    }
  };
  // Variable to track whether timer is running or not
  let isStopped = true;
  console.log(location);
  const startTimer = () => {
    if (isStopped) {
      isStopped = false;
      countContainer.innerHTML = remainingTime;
      timer = setInterval(renderTime, 1000);
      console.log("first");
    }
  };
  const resetTimer = () => {
    isStopped = true;
    clearInterval(timer);
    remainingTime = 30;
    countContainer.innerHTML = remainingTime;
  };
  const handleC = () => {
    console.log("Hello wlc");
    setValue2(true);
  };
  // useEffect(() => {

  // }, []);

  return (
    <>
      <Box
        style={{
          paddingTop: "10px",
          // background: 'white',
          position: "absolute",
          zIndex: 99,
          height: 60,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <Container>
          <HeaderSection id={1} />
        </Container>
      </Box>

      <Box
        style={{
          backgroundColor: "#515b62",
          marginTop: 75,
          color: "white",
          padding: 10,
        }}
      >
        <Container>
          {/* {setTimeout(() => {
						resetTimer();
					}, 1000),
					setTimeout(() => {
							startTimer();
						}, 3000)
					} */}
          {/* <Box display='flex'>
						<TitleText three>MusafirBazar Holiday /</TitleText>
						<TitleText three textStyle={{ marginLeft: 5 }}>
							Flight / Summary
						</TitleText>
					
					</Box> */}
        </Container>
      </Box>
      <Box style={{ background: "#e5eef4",paddingLeft:30,paddingRight:30  }}>
        {/* <Container> */}
          <Grid container spacing={2}>
            <Grid item xs={12} lg={8}>
              <Box display="flex" justifyContent="space-between" mt={"30px"}>
                <Box>
                  <TitleText
                    textStyle={{
                      fontFamily: "unset",
                      fontWeight: 500,
                      fontSize: 22,
                    }}
                  >
                    Review Your Booking
                  </TitleText>
                </Box>
                <Box display="flex" alignItems="center">
                  <i class="fa-solid fa-clock"></i>
                  <p style={{ marginLeft: 10 }}>Session Expires in</p>
                  <Box display="flex" style={{ marginLeft: 5 }}>
                    <div id="countdown-number" style={{ color: "blue" }}></div>
                  </Box>
                </Box>
              </Box>
              <Box
                style={{
                  padding: 15,
                  background: "white",
                  color: "gray",
                  border: "1px solid #e6e6e6",
                  margin: "0 0 20px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                }}
              >
                {location.state.OneflightData
                  ? location.state.OneflightData.Airline_Code
                    ? location.state.OneflightData.Segments.map((i, index) => {
                        return (
                          <>
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              mt={index > 0 ? "20px" : ""}
                            >
                              <Box display="flex" alignItems="center">
                                <Box alignItems="center" display="flex">
                                  <TitleText
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 500,
                                      fontSize: 18,
                                    }}
                                  >
                                    {location.state.OneflightData.Origin}
                                  </TitleText>
                                  -
                                  <TitleText
                                    textStyle={{
                                      fontFamily: "unset",
                                      fontWeight: 500,
                                      fontSize: 18,
                                    }}
                                  >
                                    {location.state.OneflightData.Destination}
                                  </TitleText>
                                </Box>
                                <Box
                                  ml={"30px"}
                                  style={{
                                    background: "rgb(239, 51, 57)",
                                    padding: "3px 15px",
                                    borderRadius: "50px",
                                    color: "white",
                                    fontFamily: "unset",
                                    fontWeight: 500,
                                  }}
                                >
                                  <TitleText two>ONWARD</TitleText>
                                </Box>
                              </Box>
                              <Box>{/* <BodyText>Fare Rule</BodyText> */}</Box>
                            </Box>
                            <Box mt={"20px"}>
                              <BodyText three textStyle={{fontSize:16}}>	{`${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).toLocaleString('en-us', {
											weekday: 'short',
										})} ,  ${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).getDate()} ${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).toLocaleString('en-us', {
											month: 'short',
										})},2022`}</BodyText>
                            </Box>
                            <Box
                              style={{
                                background: "white",
                                padding: "10px 15px",
                                border: "1px solid #e6e6e6",
                                marginTop: "10px",
                                borderRadius: 5,
                              }}
                            >
                              <Grid container>
                                <Grid item xs={12} sm={9} lg={9}>
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                  >
                                    <Box>
                                      <TitleText
                                        textStyle={{
                                          fontFamily: "unset",
                                          fontWeight: 500,
                                          fontSize: 18,
                                        }}
                                      >
                                        {i.Origin_City}
                                        {/* {i.Origin.Airport.AirportCode}) */}
                                      </TitleText>
                                      {/* <BodyText
																				four
																				textStyle={{
																					fontFamily: 'unset',
																					fontWeight: 500,
																				}}>
																				{i.Origin_City}
																			</BodyText> */}
                                    </Box>
                                    <Box>
                                      <TitleText
                                        four
                                        textStyle={{
                                          fontFamily: "unset",
                                          fontWeight: 500,
										  
                                        }}
                                      >
                                        {i.Departure_DateTime.substr(11, 5)}
                                      </TitleText>
                                    </Box>
                                  </Box>
                                  <Grid container alignItems="center">
                                    <Grid item xs={6} lg={9}>
                                      <Divider />
                                    </Grid>
                                    <Grid item xs={4} lg={3}>
                                      <Box
                                        style={{
                                          padding: "2px 20px",
                                          background: "rgb(239, 51, 57)",
                                          color: "white",
                                          borderRadius: 5,
                                        }}
                                      >
                                        <BodyText three textStyle={{fontSize:16}}>
                                          {timeConvert(convertH2M(i.Duration))}
                                        </BodyText>
                                      </Box>
                                    </Grid>
                                  </Grid>

                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                  >
                                    <Box>
                                      <TitleText
                                        textStyle={{
                                          fontFamily: "unset",
                                          fontWeight: 500,
                                          fontSize: 18,
                                        }}
                                      >
                                        {i.Destination_City}({i.Destination})
                                        {/* {i.Destination.Airport.AirportCode}) */}
                                      </TitleText>
                                      <BodyText
                                        four
                                        textStyle={{
                                          fontFamily: "unset",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {/* {i.Destination.Airport.AirportName}, T-3 */}
                                      </BodyText>
                                    </Box>
                                    <Box>
                                      <TitleText
                                        four
                                        textStyle={{
                                          fontFamily: "unset",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {i.Arrival_DateTime.substr(11, 5)}
                                      </TitleText>
                                    </Box>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                  <Box textAlign="center">
                                    <img
                                      src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
                                      width="50px"
                                      height="25px"
                                    ></img>
                                    <BodyText three textStyle={{fontSize:16}}>{i.Airline_Name}</BodyText>
                                    <BodyText three textStyle={{fontSize:16}}>
                                      {i.Airline_Code}-{i.Flight_Number}|
                                      Economy
                                    </BodyText>
                                    <BodyText three textStyle={{fontSize:16}}>
                                      Check-In : 1Pc - 15Kgs
                                    </BodyText >
                                    <BodyText three textStyle={{fontSize:16}}>Cabin : 7Kgs</BodyText>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                          </>
                        );
                      })
                    : location.state.OneflightData.Segments[0].map(
                        (i, index) => {
                          return (
                            <>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                mt={index > 0 ? "20px" : ""}
                              >
                                <Box display="flex" alignItems="center">
                                  <Box alignItems="center" display="flex">
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {i.Origin.Airport.CityCode}
                                    </TitleText>
                                    -
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {index == 0
                                        ? location.state.OneflightData.Segments[0]
                                            .filter((i, ind) => ind === 0)
                                            .map((one) => {
                                              return one.Destination.Airport
                                                .CityCode;
                                            })
                                        : index == 1
                                        ? location.state.OneflightData.Segments[0]
                                            .filter((i, ind) => ind === 1)
                                            .map((one) => {
                                              return one.Destination.Airport
                                                .CityCode;
                                            })
                                        : index == 2
                                        ? location.state.OneflightData.Segments[0]
                                            .filter((i, ind) => ind === 2)
                                            .map((one) => {
                                              return one.Destination.Airport
                                                .CityCode;
                                            })
                                        : ""}
                                    </TitleText>
                                  </Box>
                                  <Box
                                    ml={"30px"}
                                    style={{
                                      background: "rgb(239, 51, 57)",
                                      padding: "3px 15px",
                                      borderRadius: "50px",
                                      color: "white",
                                      fontFamily: "unset",
                                      fontWeight: 500,
                                    }}
                                  >
                                    <TitleText two>ONWARD</TitleText>
                                  </Box>
                                </Box>
                                <Box>
                                  {/* <BodyText>Fare Rule</BodyText> */}
                                </Box>
                              </Box>
                              <Box mt={"20px"}>
                                <BodyText two>Thursday, 10 Feb 2022</BodyText>
                              </Box>
                              <Box
                                style={{
                                  background: "white",
                                  padding: "10px 15px",
                                  border: "1px solid #e6e6e6",
                                  marginTop: "10px",
                                  borderRadius: 5,
                                }}
                              >
                                <Grid container>
                                  <Grid item xs={12} sm={9} lg={9}>
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                    >
                                      <Box>
                                        <TitleText
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                            fontSize: 18,
                                          }}
                                        >
                                          {i.Origin.Airport.CityName}(
                                          {i.Origin.Airport.AirportCode})
                                        </TitleText>
                                        <BodyText
                                          four
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                          }}
                                        >
                                          {i.Origin.Airport.AirportName}
                                        </BodyText>
                                      </Box>
                                      <Box>
                                        <TitleText
                                          four
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                          }}
                                        >
                                          {i.Origin.DepTime.substr(11, 5)}
                                        </TitleText>
                                      </Box>
                                    </Box>
                                    <Grid container alignItems="center">
                                      <Grid item xs={6} lg={9}>
                                        <Divider />
                                      </Grid>
                                      <Grid item xs={4} lg={3}>
                                        <Box
                                          style={{
                                            padding: "2px 20px",
                                            background: "rgb(239, 51, 57)",
                                            color: "white",
                                            borderRadius: 5,
                                          }}
                                        >
                                          <BodyText three>
                                            {timeConvert(i.Duration)}
                                          </BodyText>
                                        </Box>
                                      </Grid>
                                    </Grid>

                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                    >
                                      <Box>
                                        <TitleText
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                            fontSize: 18,
                                          }}
                                        >
                                          {i.Destination.Airport.CityName}(
                                          {i.Destination.Airport.AirportCode})
                                        </TitleText>
                                        <BodyText
                                          four
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                          }}
                                        >
                                          {i.Destination.Airport.AirportName}
                                        </BodyText>
                                      </Box>
                                      <Box>
                                        <TitleText
                                          four
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                          }}
                                        >
                                          {i.Destination.ArrTime.substr(11, 5)}
                                        </TitleText>
                                      </Box>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={3} lg={3}>
                                    <Box textAlign="center">
                                      <img
                                        src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
                                        width="50px"
                                        height="25px"
                                      ></img>
                                      <BodyText three>
                                        {i.Airline.AirlineName}
                                      </BodyText>
                                      <BodyText three>
                                        {i.Airline.AirlineCode}-
                                        {i.Airline.FlightNumber}| Economy
                                      </BodyText>
                                      <BodyText three>
                                        Check-In : 1Pc - 15Kgs
                                      </BodyText>
                                      <BodyText three>Cabin : 7Kgs</BodyText>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box>
                            </>
                          );
                        }
                      )
                  : ""}
                {/* {location.state.selectedonward
									? location.state.flightData[0].Segments[0].map((i, index) => {
											return (
												<>
													<Box
														display='flex'
														justifyContent='space-between'
														mt={index > 0 ? '20px' : ''}>
														<Box display='flex' alignItems='center'>
															<Box alignItems='center' display='flex'>
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{i.Origin.Airport.CityCode}
																</TitleText>
																-
																<TitleText
																	textStyle={{
																		fontFamily: 'unset',
																		fontWeight: 500,
																		fontSize: 18,
																	}}>
																	{index == 0
																		? location.state.flightData[0].Segments[0]
																				.filter((i, ind) => ind === 0)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: index == 1
																		? location.state.flightData[0].Segments[0]
																				.filter((i, ind) => ind === 1)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: index == 2
																		? location.state.flightData[0].Segments[0]
																				.filter((i, ind) => ind === 2)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: ''}
																</TitleText>
															</Box>
															<Box
																ml={'30px'}
																style={{
																	background: 'rgb(239, 51, 57)',
																	padding: '3px 15px',
																	borderRadius: '50px',
																	color: 'white',
																	fontFamily: 'unset',
																	fontWeight: 500,
																}}>
																<TitleText two>ONWARD</TitleText>
															</Box>
														</Box>
														<Box>
															<BodyText>Fare Rule</BodyText>
														</Box>
													</Box>
													<Box mt={'20px'}>
														<BodyText>Thursday, 10 Feb 2022</BodyText>
													</Box>
													<Box
														style={{
															background: 'white',
															padding: '10px 15px',
															border: '1px solid #e6e6e6',
															marginTop: '10px',
															borderRadius: 5,
														}}>
														<Grid container>
															<Grid item xs={12} sm={9} lg={9}>
																<Box
																	display='flex'
																	justifyContent='space-between'>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{i.Origin.Airport.CityName}(
																			{i.Origin.Airport.AirportCode})
																		</TitleText>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 600,
																				fontSize: 12,
																			}}>
																			{i.Origin.Airport.AirportName}, T-3
																		</BodyText>
																	</Box>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{i.Origin.DepTime.substr(11, 5)}
																		</TitleText>
																	</Box>
																</Box>
																<Grid container alignItems='center'>
																	<Grid item xs={6} lg={9}>
																		<Divider />
																	</Grid>
																	<Grid item xs={4} lg={3}>
																		<Box
																			style={{
																				padding: '2px 20px',
																				background: 'rgb(239, 51, 57)',
																				color: 'white',
																				borderRadius: 5,
																			}}>
																			<BodyText three>
																				{timeConvert(i.Duration)}
																			</BodyText>
																		</Box>
																	</Grid>
																</Grid>

																<Box
																	display='flex'
																	justifyContent='space-between'>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{i.Destination.Airport.CityName}(
																			{i.Destination.Airport.AirportCode})
																		</TitleText>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 600,
																				fontSize: 12,
																			}}>
																			{i.Destination.Airport.AirportName}, T-3
																		</BodyText>
																	</Box>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{i.Destination.ArrTime.substr(11, 5)}
																		</TitleText>
																	</Box>
																</Box>
															</Grid>
															<Grid item xs={12} sm={3} lg={3}>
																<Box textAlign='center'>
																	<img
																		width='50px'
																		height='25px'
																		src={
																			i.Airline.AirlineName == 'SpiceJet'
																				? spice
																				: i.Airline.AirlineName == 'Indigo'
																				? indigo
																				: i.Airline.AirlineName == 'GO FIRST'
																				? go_first
																				: i.Airline.AirlineName == 'Air India'
																				? air
																				: i.Airline.AirlineName == 'Air Asia'
																				? airasia
																				: i.Airline.AirlineName == 'Vistara'
																				? vistara
																				: ''
																		}></img>
																	<BodyText three>
																		{i.Airline.AirlineName}
																	</BodyText>
																	<BodyText three>
																		{i.Airline.AirlineCode}-
																		{i.Airline.FlightNumber}| Economy
																	</BodyText>
																	<BodyText three>
																		Check-In : 1Pc - 15Kgs
																	</BodyText>
																	<BodyText three>Cabin : 7Kgs</BodyText>
																</Box>
															</Grid>
														</Grid>
													</Box>
												</>
											);
									  })
									: ''} */}
                {location.state.selectedonward
                  ? location.state.selectedonward[0].Airline_Code
                    ? location.state.selectedonward[0].Segments.map(
                        (i, index) => {
                          return <SelectedOnwardEtravRow i={i} index={index} />;
                        }
                      )
                    : location.state.selectedonward[0].AirlineCode
                    ? location.state.selectedonward[0].Segments[0].map(
                        (i, index) => {
                          return (
                            <SelectedOnwardTboRow
                              i={i}
                              index={index}
                              selectedonward={location.state.selectedonward}
                            />
                          );
                        }
                      )
                    : ""
                  : ""}
                {/* <Box display='flex' justifyContent='space-between'>
									<Box display='flex' alignItems='center'>
										<Box alignItems='center' display='flex'>
											<TitleText
												textStyle={{
													fontFamily: 'unset',
													fontWeight: 500,
												}}>
												{location.state.flightData
													? location.state.flightData[0].Segments[0].map(
															(i) => {
																return i.Origin.Airport.CityCode;
															}
													  )
													: location.state.OneflightData
													? location.state.OneflightData.Segments[0].map(
															(i) => {
																return i.Origin.Airport.CityCode;
															}
													  )
													: ''}
											</TitleText>
											<TitleText>-</TitleText>
											<TitleText
												textStyle={{
													fontFamily: 'unset',
													fontWeight: 500,
												}}>
												{location.state.flightData
													? location.state.flightData[0].Segments[0].map(
															(i) => {
																return i.Destination.Airport.CityCode;
															}
													  )
													: location.state.OneflightData
													? location.state.OneflightData.Segments[0].map(
															(i) => {
																return i.Destination.Airport.CityCode;
															}
													  )
													: ''}
											</TitleText>
										</Box>
										<Box
											ml={'30px'}
											style={{
												background: '#39c9bb',
												padding: '3px 15px',
												borderRadius: '50px',
												color: 'white',
												fontFamily: 'unset',
												fontWeight: 500,
											}}>
											<TitleText two>ONWARD</TitleText>
										</Box>
									</Box>
									<Box>
										<BodyText>Fare Rule</BodyText>
									</Box>
								</Box>
								<Box mt={'20px'}>
									<BodyText>Thursday, 10 Feb 2022</BodyText>
								</Box>
								<Box
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										borderRadius: 15,
									}}>
									<Grid container>
										<Grid item xs={12} sm={9} lg={9}>
											<Box display='flex' justifyContent='space-between'>
												<Box>
													<TitleText
														textStyle={{
															fontFamily: 'unset',
															fontWeight: 500,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.CityName;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.CityName;
																	}
															  )
															: ''}{' '}
														(
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.AirportCode;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.AirportCode;
																	}
															  )
															: ''}
														)
													</TitleText>
													<BodyText
														two
														textStyle={{
															fontFamily: 'unset',
															fontWeight: 600,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.AirportName;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.AirportName;
																	}
															  )
															: ''}
														, T-3
													</BodyText>
												</Box>
												<Box>
													<TitleText
														textStyle={{
															fontFamily: 'unset',
															fontWeight: 500,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Origin.DepTime.substr(11, 5);
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Origin.DepTime.substr(11, 5);
																	}
															  )
															: ''}
													</TitleText>
												</Box>
											</Box>
											<Grid container alignItems='center'>
												<Grid item xs={6} lg={9}>
													<Divider />
												</Grid>
												<Grid item xs={4} lg={3}>
													<Box
														style={{
															padding: '2px 20px',
															background: '#39c9bb',
															color: 'white',
															borderRadius: 15,
														}}>
														<BodyText one>
															{location.state.flightData
																? timeConvert(
																		location.state.flightData[0].Segments[0].map(
																			(i) => {
																				return i.Duration;
																			}
																		)
																  )
																: location.state.OneflightData
																? timeConvert(
																		location.state.OneflightData.Segments[0].map(
																			(i) => {
																				return i.Duration;
																			}
																		)
																  )
																: ''}
														</BodyText>
													</Box>
												</Grid>
											</Grid>

											<Box display='flex' justifyContent='space-between'>
												<Box>
													<TitleText
														textStyle={{
															fontFamily: 'unset',
															fontWeight: 500,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.CityName;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.CityName;
																	}
															  )
															: ''}{' '}
														(
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.AirportCode;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.AirportCode;
																	}
															  )
															: ''}
														)
													</TitleText>
													<BodyText
														two
														textStyle={{
															fontFamily: 'unset',
															fontWeight: 600,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.AirportName;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.AirportName;
																	}
															  )
															: ''}
														, T-3
													</BodyText>
												</Box>
												<Box>
													<TitleText
														textStyle={{
															fontFamily: 'unset',
															fontWeight: 500,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Destination.ArrTime.substr(11, 5);
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Destination.ArrTime.substr(11, 5);
																	}
															  )
															: ''}
													</TitleText>
												</Box>
											</Box>
										</Grid>
										<Grid item xs={12} sm={3} lg={3}>
											<Box textAlign='center'>
												<img src={spice}></img>
												<BodyText two>
													{location.state.flightData
														? location.state.flightData[0].Segments[0].map(
																(i) => {
																	return i.Airline.AirlineName;
																}
														  )
														: location.state.OneflightData
														? location.state.OneflightData.Segments[0].map(
																(i) => {
																	return i.Airline.AirlineName;
																}
														  )
														: ''}
												</BodyText>
												<BodyText two>
													{location.state.flightData
														? location.state.flightData[0].Segments[0].map(
																(i) => {
																	return i.Airline.AirlineCode;
																}
														  )
														: location.state.OneflightData
														? location.state.OneflightData.Segments[0].map(
																(i) => {
																	return i.Airline.AirlineCode;
																}
														  )
														: ''}
													-
													{location.state.flightData
														? location.state.flightData[0].Segments[0].map(
																(i) => {
																	return i.Airline.FlightNumber;
																}
														  )
														: location.state.OneflightData
														? location.state.OneflightData.Segments[0].map(
																(i) => {
																	return i.Airline.FlightNumber;
																}
														  )
														: ''}{' '}
													| Economy
												</BodyText>
												<BodyText two>Check-In : 1Pc - 15Kgs</BodyText>
												<BodyText two>Cabin : 7Kgs</BodyText>
											</Box>
										</Grid>
									</Grid>
								</Box> */}
                {/* {location.state.Returnflight ? (
									<>
										<Grid
											container
											style={{ marginTop: 20, alignItems: 'center' }}>
											<Grid item xs={3}>
												<Divider />
											</Grid>
											<Grid item xs={6}>
												<Box
													style={{
														padding: '8px',
														background: '#def6f4',
														color: 'black',
														borderRadius: 50,
														textAlign: 'center',
														border: '1px solid #39c9bb',
													}}>
													<BodyText
														textStyle={{
															fontFamily: 'unset',
															fontWeight: 500,
														}}>
														Layover Time: 2hr 55mins at
													</BodyText>
												</Box>
											</Grid>
											<Grid item xs={3}>
												<Divider />
											</Grid>
										</Grid>
									</>
								) : (
									''
								)}
								{location.state.Returnflight ? (
									<>
										<Box
											style={{
												background: 'white',
												padding: '10px 15px',
												border: '1px solid #e6e6e6',
												marginTop: '20px',
												borderRadius: 15,
											}}>
											<Grid container>
												<Grid item xs={12} sm={9} lg={9}>
													<Box display='flex' justifyContent='space-between'>
														<Box>
															<TitleText
																textStyle={{
																	fontFamily: 'unset',
																	fontWeight: 500,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Origin.Airport.CityName;
																			}
																	  )
																	: ''}{' '}
																(
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Origin.Airport.AirportCode;
																			}
																	  )
																	: ''}
																)
															</TitleText>
															<BodyText
																textStyle={{
																	fontFamily: 'unset',
																	fontWeight: 600,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Origin.Airport.AirportName;
																			}
																	  )
																	: ''}
																, T-3
															</BodyText>
														</Box>
														<Box>
															<TitleText
																textStyle={{
																	fontFamily: 'unset',
																	fontWeight: 500,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Origin.DepTime.substr(11, 5);
																			}
																	  )
																	: ''}
															</TitleText>
														</Box>
													</Box>
													<Grid container alignItems='center'>
														<Grid item xs={9}>
															<Divider />
														</Grid>
														<Grid item xs={3}>
															<Box
																style={{
																	padding: '2px 20px',
																	background: '#39c9bb',
																	color: 'white',
																	borderRadius: 15,
																}}>
																<BodyText one>
																	{location.state.Returnflight
																		? timeConvert(
																				location.state.Returnflight[0].Segments[0].map(
																					(i) => {
																						return i.Duration;
																					}
																				)
																		  )
																		: ''}
																</BodyText>
															</Box>
														</Grid>
													</Grid>

													<Box display='flex' justifyContent='space-between'>
														<Box>
															<TitleText
																textStyle={{
																	fontFamily: 'unset',
																	fontWeight: 500,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Destination.Airport.CityName;
																			}
																	  )
																	: ''}{' '}
																(
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Destination.Airport
																					.AirportCode;
																			}
																	  )
																	: ''}
																)
															</TitleText>
															<BodyText
																two
																textStyle={{
																	fontFamily: 'unset',
																	fontWeight: 600,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Destination.Airport
																					.AirportName;
																			}
																	  )
																	: ''}
																, T-3
															</BodyText>
														</Box>
														<Box>
															<TitleText
																textStyle={{
																	fontFamily: 'unset',
																	fontWeight: 500,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			}
																	  )
																	: ''}
															</TitleText>
														</Box>
													</Box>
												</Grid>
												<Grid item xs={12} sm={3} lg={3}>
													<Box textAlign='center'>
														<img src={spice}></img>
														<BodyText two>
															{location.state.Returnflight
																? location.state.Returnflight[0].Segments[0].map(
																		(i) => {
																			return i.Airline.AirlineName;
																		}
																  )
																: ''}
														</BodyText>
														<BodyText two>
															{location.state.Returnflight
																? location.state.Returnflight[0].Segments[0].map(
																		(i) => {
																			return i.Airline.AirlineCode;
																		}
																  )
																: ''}
															-
															{location.state.Returnflight
																? location.state.Returnflight[0].Segments[0].map(
																		(i) => {
																			return i.Airline.FlightNumber;
																		}
																  )
																: ''}{' '}
															| Economy
														</BodyText>
														<BodyText two>Check-In : 1Pc - 15Kgs</BodyText>
														<BodyText two>Cabin : 7Kgs</BodyText>
													</Box>
												</Grid>
											</Grid>
										</Box>
									</>
								) : (
									''
								)} */}
              </Box>
              {/* {location.state.Returnflight ? (
								<Box
									style={{
										padding: 15,
										background: 'white',
										color: 'gray',
										border: '1px solid #e6e6e6',
										margin: '0 0 20px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									{location.state.Returnflight
										? location.state.Returnflight[0].Segments[0].map(
												(i, index) => {
													return (
														<>
															<Box
																display='flex'
																justifyContent='space-between'
																mt={index > 0 ? '20px' : ''}>
																<Box display='flex' alignItems='center'>
																	<Box alignItems='center' display='flex'>
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{i.Origin.Airport.CityCode}
																		</TitleText>
																		-
																		<TitleText
																			textStyle={{
																				fontFamily: 'unset',
																				fontWeight: 500,
																				fontSize: 18,
																			}}>
																			{index == 0
																				? location.state.Returnflight[0].Segments[0]
																						.filter((i, ind) => ind === 0)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: index == 1
																				? location.state.Returnflight[0].Segments[0]
																						.filter((i, ind) => ind === 1)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: index == 2
																				? location.state.Returnflight[0].Segments[0]
																						.filter((i, ind) => ind === 2)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: ''}
																		</TitleText>
																	</Box>
																	<Box
																		ml={'30px'}
																		style={{
																			background: 'rgb(239, 51, 57)',
																			padding: '3px 15px',
																			borderRadius: '50px',
																			color: 'white',
																			fontFamily: 'unset',
																			fontWeight: 500,
																		}}>
																		<TitleText two>RETURN</TitleText>
																	</Box>
																</Box>
																<Box>
																	<BodyText>Fare Rule</BodyText>
																</Box>
															</Box>
															<Box mt={'20px'}>
																<BodyText>Thursday, 10 Feb 2022</BodyText>
															</Box>
															<Box
																style={{
																	background: 'white',
																	padding: '10px 15px',
																	border: '1px solid #e6e6e6',
																	marginTop: '10px',
																	borderRadius: 5,
																}}>
																<Grid container>
																	<Grid item xs={12} sm={9} lg={9}>
																		<Box
																			display='flex'
																			justifyContent='space-between'>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 500,
																						fontSize: 18,
																					}}>
																					{i.Origin.Airport.CityName}(
																					{i.Origin.Airport.AirportCode})
																				</TitleText>
																				<BodyText
																					two
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 600,
																						fontSize: 12,
																					}}>
																					{i.Origin.Airport.AirportName}, T-3
																				</BodyText>
																			</Box>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 500,
																						fontSize: 18,
																					}}>
																					{i.Origin.DepTime.substr(11, 5)}
																				</TitleText>
																			</Box>
																		</Box>
																		<Grid container alignItems='center'>
																			<Grid item xs={6} lg={9}>
																				<Divider />
																			</Grid>
																			<Grid item xs={4} lg={3}>
																				<Box
																					style={{
																						padding: '2px 20px',
																						background: 'rgb(239, 51, 57)',
																						color: 'white',
																						borderRadius: 15,
																					}}>
																					<BodyText three>
																						{timeConvert(i.Duration)}
																					</BodyText>
																				</Box>
																			</Grid>
																		</Grid>

																		<Box
																			display='flex'
																			justifyContent='space-between'>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 500,
																						fontSize: 18,
																					}}>
																					{i.Destination.Airport.CityName}(
																					{i.Destination.Airport.AirportCode})
																				</TitleText>
																				<BodyText
																					two
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 600,
																						fontSize: 12,
																					}}>
																					{i.Destination.Airport.AirportName},
																					T-3
																				</BodyText>
																			</Box>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily: 'unset',
																						fontWeight: 500,
																						fontSize: 12,
																					}}>
																					{i.Destination.ArrTime.substr(11, 5)}
																				</TitleText>
																			</Box>
																		</Box>
																	</Grid>
																	<Grid item xs={12} sm={3} lg={3}>
																		<Box textAlign='center'>
																			<img
																				width='50px'
																				height='25px'
																				src={
																					i.Airline.AirlineName == 'SpiceJet'
																						? spice
																						: i.Airline.AirlineName == 'Indigo'
																						? indigo
																						: i.Airline.AirlineName ==
																						  'GO FIRST'
																						? go_first
																						: i.Airline.AirlineName ==
																						  'Air India'
																						? air
																						: i.Airline.AirlineName ==
																						  'Air Asia'
																						? airasia
																						: i.Airline.AirlineName == 'Vistara'
																						? vistara
																						: ''
																				}></img>
																			<BodyText three>
																				{i.Airline.AirlineName}
																			</BodyText>
																			<BodyText three>
																				{i.Airline.AirlineCode}-
																				{i.Airline.FlightNumber}| Economy
																			</BodyText>
																			<BodyText three>
																				Check-In : 1Pc - 15Kgs
																			</BodyText>
																			<BodyText three>Cabin : 7Kgs</BodyText>
																		</Box>
																	</Grid>
																</Grid>
															</Box>
														</>
													);
												}
										  )
										: ''}
								</Box>
							) : (
								''
							)} */}
              {location.state.selectedReturn ? (
                <Box
                  style={{
                    padding: 15,
                    background: "white",
                    color: "gray",
                    border: "1px solid #e6e6e6",
                    margin: "0 0 20px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  {location.state.selectedReturn[0].Airline_Code
                    ? location.state.selectedReturn[0].Segments.map(
                        (i, index) => {
                          return <SelectedReturnEtravRow i={i} index={index} />;
                        }
                      )
                    : location.state.selectedReturn[0].Segments[0].map(
                        (i, index) => {
                          return (
                            <>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                mt={index > 0 ? "20px" : ""}
                              >
                                <Box display="flex" alignItems="center">
                                  <Box alignItems="center" display="flex">
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {i.Origin.Airport.CityCode}
                                    </TitleText>
                                    -
                                    <TitleText
                                      textStyle={{
                                        fontFamily: "unset",
                                        fontWeight: 500,
                                        fontSize: 18,
                                      }}
                                    >
                                      {index == 0
                                        ? location.state.selectedReturn[0].Segments[0]
                                            .filter((i, ind) => ind === 0)
                                            .map((one) => {
                                              return one.Destination.Airport
                                                .CityCode;
                                            })
                                        : index == 1
                                        ? location.state.selectedReturn[0].Segments[0]
                                            .filter((i, ind) => ind === 1)
                                            .map((one) => {
                                              return one.Destination.Airport
                                                .CityCode;
                                            })
                                        : index == 2
                                        ? location.state.selectedReturn[0].Segments[0]
                                            .filter((i, ind) => ind === 2)
                                            .map((one) => {
                                              return one.Destination.Airport
                                                .CityCode;
                                            })
                                        : ""}
                                    </TitleText>
                                  </Box>
                                  <Box
                                    ml={"30px"}
                                    style={{
                                      background: "rgb(239, 51, 57)",
                                      padding: "3px 15px",
                                      borderRadius: "50px",
                                      color: "white",
                                      fontFamily: "unset",
                                      fontWeight: 500,
                                    }}
                                  >
                                    <TitleText two>RETURN</TitleText>
                                  </Box>
                                </Box>
                                <Box>
                                  <BodyText>Fare Rule</BodyText>
                                </Box>
                              </Box>
                              <Box mt={"20px"}>
                                <BodyText>Thursday, 10 Feb 2022</BodyText>
                              </Box>
                              <Box
                                style={{
                                  background: "white",
                                  padding: "10px 15px",
                                  border: "1px solid #e6e6e6",
                                  marginTop: "10px",
                                  borderRadius: 5,
                                }}
                              >
                                <Grid container>
                                  <Grid item xs={12} sm={9} lg={9}>
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                    >
                                      <Box>
                                        <TitleText
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                            fontSize: 18,
                                          }}
                                        >
                                          {i.Origin.Airport.CityName}(
                                          {i.Origin.Airport.AirportCode})
                                        </TitleText>
                                        <BodyText
                                          two
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 600,
                                            fontSize: 12,
                                          }}
                                        >
                                          {i.Origin.Airport.AirportName}, T-3
                                        </BodyText>
                                      </Box>
                                      <Box>
                                        <TitleText
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                            fontSize: 18,
                                          }}
                                        >
                                          {i.Origin.DepTime.substr(11, 5)}
                                        </TitleText>
                                      </Box>
                                    </Box>
                                    <Grid container alignItems="center">
                                      <Grid item xs={6} lg={9}>
                                        <Divider />
                                      </Grid>
                                      <Grid item xs={4} lg={3}>
                                        <Box
                                          style={{
                                            padding: "2px 20px",
                                            background: "rgb(239, 51, 57)",
                                            color: "white",
                                            borderRadius: 15,
                                          }}
                                        >
                                          <BodyText three>
                                            {timeConvert(i.Duration)}
                                          </BodyText>
                                        </Box>
                                      </Grid>
                                    </Grid>

                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                    >
                                      <Box>
                                        <TitleText
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                            fontSize: 18,
                                          }}
                                        >
                                          {i.Destination.Airport.CityName}(
                                          {i.Destination.Airport.AirportCode})
                                        </TitleText>
                                        <BodyText
                                          two
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 600,
                                            fontSize: 12,
                                          }}
                                        >
                                          {i.Destination.Airport.AirportName},
                                          T-3
                                        </BodyText>
                                      </Box>
                                      <Box>
                                        <TitleText
                                          textStyle={{
                                            fontFamily: "unset",
                                            fontWeight: 500,
                                            fontSize: 12,
                                          }}
                                        >
                                          {i.Destination.ArrTime.substr(11, 5)}
                                        </TitleText>
                                      </Box>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} sm={3} lg={3}>
                                    <Box textAlign="center">
                                      {/* <img
																				width='50px'
																				height='25px'
																				src={
																					i.Airline.AirlineName == 'SpiceJet'
																						? spice
																						: i.Airline.AirlineName == 'Indigo'
																						? indigo
																						: i.Airline.AirlineName ==
																						  'GO FIRST'
																						? go_first
																						: i.Airline.AirlineName ==
																						  'Air India'
																						? air
																						: i.Airline.AirlineName ==
																						  'Air Asia'
																						? airasia
																						: i.Airline.AirlineName == 'Vistara'
																						? vistara
																						: ''
																				}></img> */}
                                      <BodyText three>
                                        {i.Airline.AirlineName}
                                      </BodyText>
                                      <BodyText three>
                                        {i.Airline.AirlineCode}-
                                        {i.Airline.FlightNumber}| Economy
                                      </BodyText>
                                      <BodyText three>
                                        Check-In : 1Pc - 15Kgs
                                      </BodyText>
                                      <BodyText three>Cabin : 7Kgs</BodyText>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box>
                            </>
                          );
                        }
                      )}
                </Box>
              ) : (
                ""
              )}
              <Box display="flex" alignItems="center">
                <TitleText
                  textStyle={{
                    fontFamily: "unset",
                    fontWeight: 500,
                    fontSize: 20,
                  }}
                >
                  Contact Information{" "}
                </TitleText>
                {/* <TitleText
									textStyle={{
										marginLeft: 10,
										fontFamily: 'unset',
										fontWeight: 500,
										fontSize: 20,
									}}>
									<span
										style={{
											color: 'blue',
											fontWeight: 500,
											cursor: 'pointer',
											fontSize: 20,
										}}
										onClick={() => dispatch(toggleLoginModal(true))}>
										Sign in
									</span>{' '}
									to book faster and avail offers.{' '}
								</TitleText> */}
              </Box>
              {location.state.body ? (
                <FlightSummaryForm time={remainingTime} />
              ) : (
                <FlightSummaryReturnForm time={remainingTime} />
              )}

              {/* <Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<Box display='flex' alignItems='center'>
									<TitleText>Contact Details</TitleText>
									<BodyText textStyle={{ marginLeft: 20 }}>
										Your booking details will be sent to this email ID & mobile
										number.
									</BodyText>
								</Box>
								<SummaryForm />
							</Box> */}
              {/* <Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<Box display='flex' alignItems='center'>
									<TitleText>Contact Details</TitleText>
									<BodyText textStyle={{ marginLeft: 20 }}>
										Your booking details will be sent to this email ID & mobile
										number.
									</BodyText>
								</Box>
								<TravellerForm />
							</Box> */}
              {/* <Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<Box>
									<Box
										onClick={() => (b ? setB(false) : setB(true))}
										style={{
											padding: '8px 20px',
											// display: inline-flex;
											textalign: 'center',
											backgroundColor: '#39c9bb',
											color: 'white',
											cursor: 'pointer',
											alignItems: 'center',
											width: '10%',
										}}>
										<BodyText>Baggage</BodyText>
									</Box>
									{b ? (
										<>
											<Box
												mt={'15px'}
												ml={'20px'}
												onMouseEnter={() => setVal(true)}
												onMouseLeave={() => setVal(false)}
												style={{
													display: 'block',
													padding: '6px',
													color: 'dark',
													backgroundColor: val ? '#39c9bb' : 'white',
													border: '1px solid #39c9bb',
													borderRadius: '4px',
													transition: 'all .3s',
													textAlign: 'center',
													width: '12%',
												}}>
												<BodyText>DEL-CCU</BodyText>
											</Box>
											<Box>
												<BaggageForm />
											</Box>
											<BodyText>Total Amount = ₹ 4000</BodyText>
											<BodyText one>
												Note: Pre-booked baggage is 15% cheaper than on-board
												price
											</BodyText>
										</>
									) : (
										''
									)}
								</Box>
							</Box> */}

              {/* <Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<FormControlLabel
									control={
										<GreenCheckbox
											checked={check}
											onChange={handleCheck}
											name='checkedG'
										/>
									}
									label='SpiceJet'
								/>
							</Box> */}
            </Grid>
            <Grid item xs={12} lg={4}>
              <Box style={{ position: "sticky", top: 84 }}>
                <Box
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "62px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                    // position: 'sticky',
                    // top: 84,
                    zIndex: 1,
                  }}
                >
                  <Grid container alignItems="center">
                    <Grid item xs={4}>
                      Fare Details
                    </Grid>
                    <Grid item xs={8}>
                      <Divider style={{ background: "black" }} />
                    </Grid>
                  </Grid>
                  <Box
                    style={{
                      background: "rgba(57,201,187,.17)",
                      padding: "5px 10px",
                      margin: "10px 0 0",
                      borderRadius: "15px",
                    }}
                  >
                    <BodyText textStyle={{ fontSize: 13 }}>
                      AMOUNT TO BE PAID
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 18 }}>
                      {location.state.returnBody
                        ? `₹ ${Number(
                            location.state.selectedonward &&
                              location.state.selectedReturn
                              ? location.state.selectedonward[0].Airline_Code
                                ? Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares[0]
                                        .FareDetails[0].Basic_Amount
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares[0]
                                        .FareDetails[0].AirportTax_Amount
                                    )
                                  ) -
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares[0]
                                        .FareDetails[0].Net_Commission
                                    )
                                  ) +
                                  // Number(
                                  // 	Math.round(
                                  // 		net
                                  // 			? 0
                                  // 			: location.state.OneflightData.Fares[0]
                                  // 					.FareDetails[0].agentMarkup
                                  // 	)
                                  // ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares[0]
                                        .FareDetails[0].TDS
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares[0]
                                        .FareDetails[0].markup
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedonward[0].Fares[0]
                                        .FareDetails[0].partnerMarkup
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fares[0]
                                        .FareDetails[0].Basic_Amount
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fares[0]
                                        .FareDetails[0].AirportTax_Amount
                                    )
                                  ) -
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fares[0]
                                        .FareDetails[0].Net_Commission
                                    )
                                  ) +
                                  // Number(
                                  // 	Math.round(
                                  // 		net
                                  // 			? 0
                                  // 			: location.state.OneflightData.Fares[0]
                                  // 					.FareDetails[0].agentMarkup
                                  // 	)
                                  // ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fares[0]
                                        .FareDetails[0].TDS
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fares[0]
                                        .FareDetails[0].markup
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fares[0]
                                        .FareDetails[0].partnerMarkup
                                    )
                                  )
                                : Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fare
                                        .BaseFare
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fare.Tax
                                    )
                                  ) +
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fare
                                        .TdsOnPLB
                                    )
                                  )
                              : ""
                          )}`
                        : location.state.OneflightData
                        ? `₹ ${Number(
                            location.state.OneflightData.Supplier === "ETR"
                              ? Math.round(
                                  location.state.OneflightData.Fares
                                    .Total_Amount
                                )
                              : Math.round(
                                  location.state.OneflightData.Fare.Total_Amount
                                )
                          )}`
                        : ""}
                    </TitleText>
                    <span>(inclusive of all taxes.)</span>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt={"10px"}
                  >
                    <BodyText textStyle={{ fontSize: 13 }}>
                      Adultx
                      {location.state.body
                        ? location.state.body.AdultCount
                        : location.state.returnBody
                        ? location.state.returnBody.AdultCount
                        : ""}
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 13 }}>
                      {location.state.returnBody
                        ? `₹ ${
                            Number(
                              location.state.selectedonward
                                ? location.state.selectedonward[0].Airline_Code
                                  ? Number(
                                      Math.round(
                                        location.state.selectedonward[0]
                                          .Fares[0].FareDetails[0].Basic_Amount
                                      )
                                    ) +
                                    Number(
                                      Math.round(
                                        location.state.selectedonward[0]
                                          .Fares[0].FareDetails[0]
                                          .Net_Commission
                                      )
                                    ) +
                                    Number(
                                      Math.round(
                                        location.state.selectedonward[0]
                                          .Fares[0].FareDetails[0]
                                          .Service_Fee_Amount
                                      )
                                    ) +
                                    Number(
                                      Math.round(
                                        location.state.selectedonward[0]
                                          .Fares[0].FareDetails[0].TDS
                                      )
                                    ) +
                                    Number(
                                      Math.round(
                                        location.state.selectedonward[0]
                                          .Fares[0].FareDetails[0].agentMarkup
                                      )
                                    ) +
                                    Number(
                                      Math.round(
                                        location.state.selectedonward[0]
                                          .Fares[0].FareDetails[0].partnerMarkup
                                      )
                                    )
                                  : ""
                                : ""
                            ) * Number(location.state.returnBody.AdultCount)
                          }`
                        : location.state.OneflightData
                        ? `₹ ${Number(
                            location.state.OneflightData.Supplier === "ETR"
                              ? Math.round(
                                  location.state.OneflightData.Fares
                                    .Basic_Amount
                                )
                              : Math.round(
                                  location.state.OneflightData.Fare.Basic_Amount
                                )
                          )}`
                        : ""}
                    </TitleText>
                  </Box>
                  {baggage || baggageChild1 ? (
                    <Box display="flex" justifyContent="space-between">
                      <BodyText textStyle={{ fontSize: 13 }}>Add-Ons</BodyText>
                      <TitleText textStyle={{ fontSize: 13 }}>{`₹ ${
                        Number(baggage ? baggage : "") +
                        Number(baggageAdult2 ? baggageAdult2 : "") +
                        Number(baggageAdult3 ? baggageAdult3 : "") +
                        Number(baggageAdult4 ? baggageAdult4 : "") +
                        Number(baggageAdult5 ? baggageAdult5 : "") +
                        Number(baggageAdult6 ? baggageAdult6 : "") +
                        Number(baggageAdult7 ? baggageAdult7 : "") +
                        Number(baggageAdult8 ? baggageAdult8 : "") +
                        Number(baggageAdult9 ? baggageAdult9 : "") +
                        Number(baggageChild1 ? baggageChild1 : "") +
                        Number(baggageChild2 ? baggageChild2 : "") +
                        Number(baggageChild3 ? baggageChild3 : "") +
                        Number(baggageChild4 ? baggageChild4 : "") +
                        Number(baggageChild5 ? baggageChild5 : "") +
                        Number(baggageChild6 ? baggageChild6 : "") +
                        Number(baggageChild7 ? baggageChild7 : "") +
                        Number(baggageChild8 ? baggageChild8 : "") +
                        Number(baggageChild9 ? baggageChild9 : "")
                      }`}</TitleText>
                    </Box>
                  ) : (
                    ""
                  )}

                  <Box display="flex" justifyContent="space-between">
                    <BodyText textStyle={{ fontSize: 13 }}>
                      Total Taxes
                    </BodyText>
                    <TitleText textStyle={{ fontSize: 13 }}>
                      ₹{" "}
                     { Number(
                              location.state.OneflightData.Supplier === "ETR"
                                ? Math.round(location.state.OneflightData.Fares
                                    .AirportTax_Amount)
                                : Math.round(location.state.OneflightData.Fare.AirportTax_Amount)
                            )}
                    </TitleText>
                  </Box>
                  <Divider />
                  {value ? (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      mt={"5px"}
                      mb={"5px"}
                    >
                      <BodyText>Convenience Fees</BodyText>
                      <TitleText two>Rs 200</TitleText>
                    </Box>
                  ) : (
                    ""
                  )}

                  <Divider />
                </Box>
                {/* <Box
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
										// position: 'sticky',
										// top: value ? 320 : 275,
										zIndex: 1,
									}}>
									<Grid container alignItems='center'>
										<Grid item xs={4}>
											Promo Code
										</Grid>
										<Grid item xs={8}>
											<Divider style={{ background: 'black' }} />
										</Grid>
									</Grid>
									<Box className={classes.radio}>
										<RadioGroup
											aria-label='gender'
											name='gender1'
											value={value}
											// onChange={handleChange}
										>
											<FormControlLabel
												value='female'
												control={<Radio onClick={handleClick} />}
												label='NOFEES'
											/>
											<BodyText three textStyle={{ marginLeft: 10 }}>
												Use this promo ad save 200
											</BodyText>
										</RadioGroup>
									</Box>
								</Box> */}
              </Box>
            </Grid>
          </Grid>
        {/* </Container> */}
      </Box>
      <AddGSTModal />
      <TermConditionModal />
      <Drawers />
      <SessionExpireModal />
      <Login />
    </>
  );
};

export default SummaryFlight;
